import React, { Component } from 'react';
import ReactDOM from 'react-dom';

//IMPORT IMAGES
import TravauxNew from '../../../assets/svg/TravauxNew.svg';
import { translate } from "react-translate";


// JSX
import Works from './Works.jsx'
import Work from './Work.jsx'

// CSS
import './TravauxScrollbar.css'
import './TravauxComponent.css'

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
  Button,
  Container,
  Segment,
  Menu,
  Image,
  Dropdown,
  Header,
  List,
  Grid,
  Search,
  Advertisement,
  Icon,
  Divider,
  Table,
  Input,
  Item,
} from 'semantic-ui-react';
// REDUX Maxence
import { connect } from 'react-redux';
import {
  addWorkId,
  addToListCondition,
  addCalculResult,
  addAtlError,
  addCalculError
} from '../../../redux/actions/ConfigFileAction'

import _ from 'lodash'

import { Currencies } from '../../../constants/Currencies';

import API from '../../../services/api';

const mapStateToProps = state => ({
  app: state.app,
  configfile: state.configfile
})

const mapActionToProps = {
  addWorkId: addWorkId,
  addCalculResult: addCalculResult,
  addAtlError: addAtlError,
  addCalculError: addCalculError
}

class ConnectedTravauxComponent extends React.Component {

  constructor(props) {
    super(props)

    let status;

    if (this.props.match.params.beta != undefined) {
      status = "beta"
    } else {
      status = "prod"
    }

    this.state = {
      check: false,
      configFile: null,
      title: false,
      isPro: true,
      userUnit: 'Meter',
      currency: "€",
      option: null,
      status: status,
      isLoading: false,
      source: [],
      searchResults: [],
      showResults: [],
      value: '',
      filteredProWorks: false
    }

    // This binding is necessary to make `this` work in the callback
    this.handleClickWorks = this.handleClickWorks.bind(this);
    this.handleClickPrevious = this.handleClickPrevious.bind(this);
    this.addWorkId = this.addWorkId.bind(this);
    // this.onChange = this.onChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleResultSelect = this.handleResultSelect.bind(this)
    this.handleFilterProWorks = this.handleFilterProWorks.bind(this)
  }

  //Redux
  addWorkId(id) {
    this.props.addWorkId(id)
  }

  handleClickWorks(e) {
    e.preventDefault();

    this.addWorkId(e.target.id);

    ReactDOM.findDOMNode(this).lastChild.scrollTop = 0

    this.setState({
      title: e.target.title
    })
  }

  handleClickPrevious(e) {
    this.props.addCalculResult({})
    this.props.addAtlError(null)
    this.props.addCalculError(null)
    this.props.addWorkId(null)

    this.setState({
      title: false
    })

    if (this.props.match.params.id != undefined) {
      window.location.replace("/works");
    }
  }

  convertToSearchModel(response) {
    const { t } = this.props;
    let source = []

    Object.entries(response).map((key, mainindex) => {
      let title = key[1].Work[this.props.app.lang] !== undefined ?
        key[1].Work[this.props.app.lang] :
        key[1].Work['fr_FR']
      let description = key[1].Description[this.props.app.lang] !== undefined ?
        key[1].Description[this.props.app.lang] :
        key[1].Description['fr_FR']
      let sourceValue = {
        title: title,
        description: description,
        image: API.resourceURL + '/upload/iconsworks/' + key[1].Icon,
        price: '',
        response_key: key[0],
        pro: key[1].Pro === 'true' ? 'true' : 'false',
      }
      source.push(sourceValue);
    })

    return source;
  }

  resetComponent() {
    this.setState({
      isLoading: false,
      searchResults: [],
      showResults: this.state.configFile.ListWorks,
      value: ''
    })
  }

  handleResultSelect(e, { result }) {
    let showResults = {}
    showResults[result.response_key] = this.state.configFile.ListWorks[result.response_key]
    this.setState({
      value: result.title,
      showResults: showResults
    })
  }

  handleSearchChange(e, { value }) {
    this.setState({
      isLoading: true, value
    })

    setTimeout(() => {
      if (this.state.value.length < 1) return this.resetComponent()

      const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
      const isMatch = result => re.test(result.title)
      let searchResults = _.filter(this.state.source, isMatch)
      let showResults = {}
      for (let i = 0; i < searchResults.length; i++) {
        showResults[searchResults[i].response_key] = this.state.configFile.ListWorks[searchResults[i].response_key]
      }

      this.setState({
        isLoading: false,
        searchResults: searchResults,
        showResults: showResults
      })
    }, 300)
  }

  handleFilterProWorks(e) {
		this.setState({
      isLoading: true
    })

    setTimeout(() => {
			const { source, configFile, filteredProWorks } = this.state
			let searchResults = source
			if (!filteredProWorks) {
      	searchResults = _.filter(
					source,
					function(item) { return item.pro === 'true'; }
				)
			}
      let showResults = {}
      for (let i = 0; i < searchResults.length; i++) {
        showResults[searchResults[i].response_key] = configFile.ListWorks[searchResults[i].response_key]
      }

			this.setState({
        isLoading: false,
        searchResults: searchResults,
        showResults: showResults,
				filteredProWorks: !filteredProWorks
      })
    }, 300)
	}


  componentWillMount() {
    window.scrollTo(0, 0)

    // this.getV2EnvironmentInfo()
		this.getUserInfo(this.getV3EnvironmentInfo.bind(this))
  }

	getV2EnvironmentInfo() {
    var self = this;
    var envData = {
      status: this.state.status,
      lang: this.props.app.lang
    }
    API.getEnv(this.props.app.token, envData).then((res) => {
      var response = res.data;
      var link = response.link;
      API.getConfigFile(link).then((configFileRes) => {
        API.getUser(self.props.app.token).then((userRes) => {
					let source = []
					let works = configFileRes.data.ListWorks
					source = self.convertToSearchModel(works)
					let tmpResponseCurrencies = Currencies.filter(currency => currency.value == userRes.data.currency);
					self.setState({
						currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
						userUnit: userRes.data.unit,
						configFile: configFileRes.data,
						check: true,
						showResults: works,
						source: source
					})
        });
      })
    });
	}

	getV3EnvironmentInfo() {
		var proInfoUrl = API.resourceURL + '/v3/environment/info/{"status":"beta","lang":"'+this.props.app.lang+'","c":"1"}';
		let xhrV3EnvInfo = new XMLHttpRequest();
		xhrV3EnvInfo.responseType = "json";
		xhrV3EnvInfo.open("GET", proInfoUrl, true);
		xhrV3EnvInfo.setRequestHeader("Authorization", "Bearer " + this.props.app.token);

		xhrV3EnvInfo.send();

		xhrV3EnvInfo.onload = () => {
			this.getLinkInd(xhrV3EnvInfo.response['linkind'], xhrV3EnvInfo.response['linkpro'])
		}
	}

	getLinkInd(url, proUrl) {
		let xdr = new XMLHttpRequest();
		xdr.responseType = "json";
		xdr.open("GET", url);

		xdr.send();

		xdr.onload = () => {
			let source = []
			let works = xdr.response.ListWorks
			// set search models
			source = this.convertToSearchModel(works)
			this.setState({
				configFile: xdr.response,
				showResults: works,
				source: source,
				check: true,
			}, () => {
				this.getLinkPro(proUrl)
			})
		}
	}

	getLinkPro(url) {
    var self = this;
    API.getConfigFile(url).then((response) => {
      let configFile = this.state.configFile
      let source = []
      let works = this.state.showResults
      let proWorks = response.data['ListWorks']
      Object.entries(proWorks).map((proWork, index) => {
        works.push(proWork[1])
      })
      configFile.ListWorks = works
      source = self.convertToSearchModel(works)
      self.setState({
        configFile: configFile,
        showResults: works,
        source: source,
        check: true,
      })
    });
	}

	getUserInfo(callback) {
    var self = this;
    API.getUser(this.props.app.token).then((res) => {
      let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
			self.setState({
				currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
				userUnit: res.data.unit,
				check: false,
			}, () => {
				callback()
			})
    });
	}

  render() {

    if (this.state.check) {
      let reloadConfigFile = true
      Object.entries(this.state.configFile.Changes).map((key, Mainindex) => {
        if (this.props.app.lang == key[0]) {
          reloadConfigFile = false;
        }
      })
      if (reloadConfigFile) {
        this.componentWillMount()
      }
    }

    let workId, title;

    const { t } = this.props;
    const { isLoading, value, searchResults, showResults } = this.state

    return (
      <Grid stackable id="travaux">
        <Grid.Row verticalAlign='middle' columns={2} id="headerSection">
          <Grid.Column verticalAlign='middle' tablet={4} computer={4}>
            <Segment basic>
                  <Item.Image size='mini' src={TravauxNew} id="imageSection" />
                  <Item.Content verticalAlign='middle'>
                    <Item.Header as='h3' id="titleSection">{this.props.configfile.workId ? (this.state.title) : (t("travaux"))}</Item.Header>
                  </Item.Content>
            </Segment>
          </Grid.Column>
          <Grid.Column verticalAlign='middle' tablet={6} computer={this.state.isPro? 8 : 12}>
            <Search id='SearchColumn' input={{ fluid: 'true' }} placeholder={t("filter_work")}
              loading={isLoading}
              onResultSelect={this.handleResultSelect}
              onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
              results={searchResults}
              value={value}
              className={this.state.searchResults.length >= 1 ? 'search_bar' : ''}
              {...this.props}
            />
          </Grid.Column>
					{this.state.isPro ? (
						<Grid.Column textAlign='center' verticalAlign='middle' mobile={16} tablet={6} computer={4}>
							<Button
                    fluid
                    circular
                    size='small'
                    className={this.state.filteredProWorks ? '' : 'pro_filter_button'}
                    id="smallBtn"
                    onClick={this.handleFilterProWorks}>
                    <Icon name='filter'/>
                    {this.state.filteredProWorks ? t('show_all_works') : t('filter_travaux_pro')}    
							</Button>
						</Grid.Column>
					):(
						<div />
					)}
          <Divider />
        </Grid.Row>

        {/*<div style={{ height: '600px', overflowY: 'scroll', margin: '20px 0', overflowX: 'hidden' }} className='travaux_scrollbar'>*/}
          {
            this.state.check ? (
              <Grid.Row verticalAlign='middle'>
                {(this.props.match.params.id !== undefined ? this.props.match.params.id : this.props.configfile.workId) !== null ? (
                  <Grid centered stackable doubling columns={2}>

                    {Object.entries(this.state.configFile.ListWorks).map((key, Mainindex) => {
                      workId = key[1].WorkId;

                      let description, workTitle, howToLink, howToText;
                      let configFileLang = 'fr_FR';

                      Object.entries(this.state.configFile.Changes).map((key, Mainindex) => {
                        if (key[0] != 'fr_FR') {
                          configFileLang = key[0];
                        }
                      })

                      Object.entries(key[1].Description).map((key, Mainindex) => {
                        if (key[0] === this.props.app.lang) {
                          description = key[1]
                        }
                      })
                      Object.entries(key[1].Work).map((key, Mainindex) => {
                        if (key[0] === this.props.app.lang) {
                          workTitle = key[1]
                        }
                      })
                      Object.entries(key[1].HowTo).map((key, Mainindex) => {
                        if (key[0] === "HowToText") {
                          Object.entries(key[1]).map((key, Mainindex) => {

                            if (key[0] === this.props.app.lang) {
                              howToText = key[1]
                            }
                          })
                        }
                        if (key[0] === "HowToLink") {
                          Object.entries(key[1]).map((key, Mainindex) => {
                            if (key[0] === this.props.app.lang) {
                              howToLink = key[1]
                            }
                          })
                        }
                      })
                      if (workId === (this.props.match.params.id !== undefined ? this.props.match.params.id : this.props.configfile.workId)) {
                        if (this.state.title != workTitle) {
                          this.setState({
                            title: workTitle
                          })
                        }
                        return (
                          <Work key={Mainindex} group={key[1].Group}
                            workId={(this.props.match.params.id !== undefined ? this.props.match.params.id : this.props.configfile.workId)}
                            currency={this.state.currency}
                            howToLink={howToLink} howToText={howToText}
                            addToListCondition={key[1].AddToList}
                            raz={key[1].RAZandCalculationate}
                            pictureWeb={key[1].Pictureweb}
                            pictureMobile={key[1].Picturemobile}
                            description={description} workTitle={workTitle}
                            unit={this.state.userUnit} lang={this.props.app.lang}
                            prevPath={[t("travaux"), workTitle]}
                            prevPathCallback={this.handleClickPrevious}
                            configFileLang={configFileLang}
														pro={key[1].Pro}
                          />
                        )
                      }
                    })}

                  </Grid>
                ) : (
                    <Grid doubling padded columns={5}>
                      {Object.entries(showResults).map((key, Mainindex) => {

                        workId = key[1].WorkId;
                        Object.entries(key[1].Work).map((key, Mainindex) => {

                          if (key[0] === this.props.app.lang) {
                            title = key[1]
                          }
                        })

                        return (
                          <Grid.Column id={workId} key={Mainindex} onClick={this.handleClickWorks}>
                            <Works id={workId} isPro={this.state.isPro}
                              pro={key[1].Pro && key[1].Pro == 'true' ? true : false} title={title} img={key[1].Icon} />
                          </Grid.Column>
                        )

                      })}
                    </Grid>
                  )}

              </Grid.Row>
            ) : (
                <Grid doubling padded columns={5}>
                  <Grid.Column verticalAlign='middle' width={5}>
                    <Segment basic>
                      <Item.Group>
                        <Item>
                          <Item.Image size='mini' className='travaux-item-image' src={TravauxNew} />
                          <Item.Content verticalAlign='middle'>
                            <Item.Header id='travaux-item-header'>{t("loading")}</Item.Header>
                          </Item.Content>
                        </Item>
                      </Item.Group>
                    </Segment>
                  </Grid.Column>
                </Grid>
              )
          }
        {/*</div>*/}

      </Grid>
    );
  }
}

const TravauxComponent = connect(mapStateToProps, mapActionToProps)(ConnectedTravauxComponent);
export default translate("TravauxComponent")(TravauxComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/TravauxComponent.js